import * as VueGoogleMaps from "vue2-google-maps";
import Vue from "vue";

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.GOOGLE_MAPS_API_KEY || "AIzaSyACBt3922BJ2jikHmHbRMX6B7OfzZuzBBM",
    v: "quarterly", // most stable channel
    libraries: "geometry",
  },
});
